import { useState } from "react";
import {
  Container,
  DescriptionComponent,
  TitleComponent,
} from "../../global_styles/styles";
import Country, { CountryType } from "./Country";
import StudentResults from "./StudentResults";
import { TitleWrapper } from "./styless";
import useQueryCustom from "../../hooks/useQueryCustom";

const Students: React.FC = () => {
  const countries: CountryType[] | [] = useQueryCustom(
    "/countries.json",
    "countries"
  );
  const [selectedCountry, setSelectedCountry] = useState<CountryType>();

  return (
    <Container>
      <TitleWrapper>
        <TitleComponent>Our students everywhere</TitleComponent>
        <DescriptionComponent>
          Discover what sets us apart – our key strengths that drive our success
        </DescriptionComponent>
        <Country selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} countries={countries} />
      </TitleWrapper>
      <StudentResults selectedCountry={selectedCountry} />
    </Container>
  );
};

export default Students;
